import React from "react";
import classNames from "classnames";
import ReactSelect from "react-select";
import getConfig from "next/config";

const {
  publicRuntimeConfig: { settings },
} = getConfig();

const SelectSearch = (props) => {
  const hasError = props.meta && props.meta.touched && props.meta.error;

  return (
    <>
      {props.label && (
        <label
          htmlFor={props.id}
          className={`
            Form-label
            ${props.labelClass && props.labelClass}
            ${props.required ? "is-required" : ""}
            ${props.disabled ? "disabled" : ""}
          `}
        >
          {typeof props.label === "string" ? (
            <span
              dangerouslySetInnerHTML={{ __html: props.label }}
              className="inline-block"
            ></span>
          ) : (
            props.label
          )}
        </label>
      )}

      <div
        className={`select-with-search w-full relative ${props.containerClassName}`}
      >
        <ReactSelect
          components={{
            IndicatorSeparator: () => null,
            Control,
            Option,
            Menu,
            IndicatorsContainer,
          }}
          instanceId={props.id}
          isDisabled={props.disabled}
          isClearable={false}
          hasError={hasError}
          controlClassName={props.controlClassName}
          menuPlacement={props.menuPlacement || "top"}
          maxMenuHeight={props.maxMenuHeight || 260}
          menuShouldScrollIntoView={true}
          menuClassName={props.menuClassName}
          placeholder={
            <div className="text-black text-base font-normal leading-18.2">
              {props.placeholder}
            </div>
          }
          options={props.options}
          styles={{
            valueContainer: (rest) => ({
              ...rest,
              ...props.valueContainerStyle,
            }),
          }}
          {...props.input}
        />

        {props.loadingData && (
          <div className="ui dimmer inverted active">
            <div className="ui loader" />
          </div>
        )}
      </div>

      {hasError && (
        <div className="text-red-brand text-sm mt-2px">{props.meta.error}</div>
      )}

      <style>{`
        .select-with-search .has-check:after {
          content: url(${settings.websiteStatics}/images/check.svg);
          display: inline-block;
          float: right;
        }
      `}</style>
    </>
  );
};

const colors = {
  selected:
    settings.websiteName === "altex" || settings.websiteName === "bricostore"
      ? "text-red-brand has-check"
      : "bg-secondary text-white",
};

const Menu = ({
  children,
  innerRef,
  innerProps,
  getStyles,
  selectProps,
  ...rest
}) => {
  const { menuClassName } = selectProps;

  return (
    <div
      ref={innerRef}
      {...innerProps}
      style={{
        ...getStyles("menu", rest),
        marginTop: "-1px",
        borderTopLeftRadius: 0,
        borderTopRightRadius: 0,
      }}
      className={classNames({
        [menuClassName]: menuClassName,
      })}
    >
      {children}
    </div>
  );
};

const Control = ({
  children,
  innerRef,
  innerProps,
  isDisabled,
  isFocused,
  selectProps,
}) => {
  const { controlClassName } = selectProps;

  return (
    <div
      ref={innerRef}
      {...innerProps}
      className={classNames({
        "flex rounded-bl-lg rounded-tr-lg justify-between border shadow-inner overflow-hidden": true,
        "border-gray-1100": !selectProps.hasError,
        "border-red-brand bg-red-bg": selectProps.hasError,
        "opacity-50": isDisabled,
        "rounded-b-none": selectProps.hasError || isFocused,
        [controlClassName]: controlClassName,
      })}
      style={{
        height: "44px",
        maxWidth: "390px",
        minWidth: "260px",
        background: "white",
      }}
    >
      {children}
    </div>
  );
};

const Option = ({
  children,
  innerRef,
  innerProps,
  getStyles,
  isSelected,
  isFocused,
  ...rest
}) => (
  <div
    ref={innerRef}
    {...innerProps}
    className={classNames({
      "active:bg-newGray hover:bg-newGray": !isSelected,
      "bg-newGray": isFocused,
      [colors.selected]: isSelected,
    })}
    style={{
      ...getStyles("option", rest),
      backgroundColor: null,
      color: null,
    }}
  >
    {children}
  </div>
);

const IndicatorsContainer = ({
  children,
  innerRef,
  innerProps,
  getStyles,
  selectProps,
  ...rest
}) => {
  return (
    <div
      ref={innerRef}
      {...innerProps}
      className={classNames({
        "rotate-180": selectProps.menuIsOpen,
      })}
      style={{
        ...getStyles("indicatorsContainer", rest),
      }}
    >
      {children}
    </div>
  );
};

SelectSearch.defaultProps = {
  id: null,
  label: "",
  required: false,
  disabled: false,
  placeholder: "",
};

export default SelectSearch;
